import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var DomainRedirectGuard = /** @class */ (function () {
    function DomainRedirectGuard(router) {
        this.router = router;
    }
    DomainRedirectGuard.prototype.canActivate = function () {
        var hostname = window.location.hostname;
        var specialDomain = 'terms.noknok.co';
        if (hostname === specialDomain) {
            // Show terms-and-conditions while keeping URL '/'
            this.router.navigateByUrl('/terms-and-conditions', { skipLocationChange: true });
            return false;
        }
        // For all other domains, redirect to login
        this.router.navigate(['/portal/login']);
        return false; // prevents loading the current '' route
    };
    DomainRedirectGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DomainRedirectGuard_Factory() { return new DomainRedirectGuard(i0.ɵɵinject(i1.Router)); }, token: DomainRedirectGuard, providedIn: "root" });
    return DomainRedirectGuard;
}());
export { DomainRedirectGuard };
